define('views/pages/wishlist/offers/filter-days',['require','jquery','views/base/collection','./filter-day'],function(require) {
    'use strict';

    var $ = require('jquery'),
        CollectionView = require('views/base/collection'),
        FilterDayView = require('./filter-day');

    var FilterDaysView = CollectionView.extend({
        autoRender: true,
        tagName: 'ul',
        className: 'filter-days',
        itemView: FilterDayView,
        region: 'wishlist-result-filter-days',
        listen: {
            'changed': 'render'
        }
    });

    return FilterDaysView;
});

